import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StatusService {

    membershipStatus = signal<string>('');

    setMembershipStatus(status: string) {
        this.membershipStatus.set(status);
    }
}